import { useApi } from '~/composables/useApi';
import { Aggregation, ProductAttributeFilterInput, Products } from '~/modules/GraphQL/types';
import GetProductFilterByCategoryQuery from '~/modules/catalog/category/components/filters/command/getProductFilterByCategory.gql';
import getProductFiltersByCategoryTerm from '~/modules/catalog/category/components/filters/command/getProductFilterByCategoryTerm.gql';
import { MatchEnumSettings } from '~/modules/GraphQL/types';

export const getProductFilterByCategoryCommand = {
  execute: async (filter: ProductAttributeFilterInput, queryInstance?: Function): Promise<Aggregation[]> => {
    const { query } = queryInstance ? { query: queryInstance } : useApi();
    const { data } = await query<{ products: Products }>(GetProductFilterByCategoryQuery, { filter });

    return data?.products?.aggregations ?? [];
  },
  executeSearch: async (searchTerm: String, fetchedFilters: ProductAttributeFilterInput, allIds: Array<String>, queryInstance?: Function): Promise<Aggregation[]> => {
    const { query } = queryInstance ? { query: queryInstance } : useApi();
    
    const searchParams = {
      filter: { 
        name: { match: searchTerm, match_type: MatchEnumSettings.PARTIAL }, 
        category_id: { in: allIds },
        ...fetchedFilters 
      }
    }

    const { data } = await query<{ products: Products }>(getProductFiltersByCategoryTerm, searchParams);

    return data?.products?.aggregations ?? [];
  },
};

export default getProductFilterByCategoryCommand;
